import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Login.css';
import logo from '../../assets/img.png';
import axiosInstance from "../../api/axiosConfig.jsx";

const ForgotPassword = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: '',
    });
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [language, setLanguage] = useState('nl');

    const toggleLanguage = () => {
        setLanguage((prevLanguage) => (prevLanguage === 'nl' ? 'en' : 'nl'));
    };

    // Error messages in different languages
    const errorMessages = {
        nl: {
            emailNotFound: 'E-mailadres niet gevonden.',
            resetError: 'Fout bij het verzenden van de reset link.',
            invalidEmail: 'Ongeldig e-mailadres.',
        },
        en: {
            emailNotFound: 'Email address not found.',
            resetError: 'Error sending reset link.',
            invalidEmail: 'Invalid email address.',
        },
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccess(null);

        try {
            const response = await axiosInstance.post('/users/forgot-password', formData);
            if (response.status === 200) {
                setSuccess(language === 'nl'
                    ? 'Als dit e-mailadres bij ons bekend is, ontvangt u binnen enkele minuten een e-mail met instructies voor het resetten van uw wachtwoord.'
                    : 'If this email address is registered with us, you will receive password reset instructions within a few minutes.');
                setTimeout(() => {
                    navigate('/login');
                }, 5000); // Redirect after 5 seconds
            }
        } catch (error) {
            console.log(error);
            if (error.response && error.response.data) {
                const translatedMessage = translateErrorMessage(error.response.data);
                setError(translatedMessage);
            } else {
                setError(language === 'nl' ? errorMessages.nl.resetError : errorMessages.en.resetError);
            }
        }
    };

    const translateErrorMessage = (message) => {
        switch (message) {
            case 'EMAIL_NOT_FOUND':
                return errorMessages[language].emailNotFound;
            case 'INVALID_EMAIL':
                return errorMessages[language].invalidEmail;
            default:
                return language === 'nl' ? 'Onbekende fout opgetreden.' : 'An unknown error occurred.';
        }
    };

    return (
        <div className="container-fluid vh-100 d-flex justify-content-center align-items-center" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh', minWidth: '100vw' }}>
            <div className="card shadow-lg p-4" style={{ maxWidth: '400px', width: '100%', borderRadius: '15px', backgroundColor: '#ffffff', maxHeight: '90vh', overflowY: 'auto' }}>
                <div className="text-center mb-4">
                    <img src={logo} alt="HorecaMasters Logo" style={{ maxWidth: '250px', height: '130px' }} />
                </div>
                <h2 className="text-center mb-4" style={{ fontSize: '1.5rem', color: '#343a40' }}>
                    {language === 'nl' ? 'Wachtwoord Vergeten' : 'Forgot Password'}
                </h2>

                {error && <div className="alert alert-danger">{error}</div>}
                {success && <div className="alert alert-success">{success}</div>}

                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label htmlFor="email" className="form-label">{language === 'nl' ? 'E-mail' : 'Email'}</label>
                        <input
                            type="email"
                            className="form-control"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder={language === 'nl' ? 'Voer je e-mailadres in' : 'Enter your email'}
                            required
                        />
                    </div>
                    <button type="submit" className="btn btn-success w-100">
                        {language === 'nl' ? 'Verstuur Reset Link' : 'Send Reset Link'}
                    </button>
                    <div className="form-check form-switch mt-3 text-center">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="languageSwitch"
                            onChange={toggleLanguage}
                            checked={language === 'en'}
                        />
                        <label className="form-check-label" htmlFor="languageSwitch">
                            {language === 'nl' ? 'Schakel naar Engels' : 'Switch to Dutch'}
                        </label>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ForgotPassword;